import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { AppConfigService } from '@tmhcc-ng-lib/global-services';
import { BaseDataService } from './base-data-service';
import { ActivityLogResponse } from './def/steps';
import { GlobalVariablesService } from './global-variables.service';
import {
  EndorsementContactRequest,
  AvailableEndorsementRequest
} from './def/additional-insured';

@Injectable({
  providedIn: 'root'
})
export class AdditionalInsuredService extends BaseDataService {
  constructor(
    protected http: HttpClient,
    protected configService: AppConfigService,
    protected globalVariables: GlobalVariablesService
  ) {
    super(http, configService, globalVariables);
  }

  saveEndorsementContact(payload: EndorsementContactRequest): Observable<any> {
    const url = `${this.serviceBaseUrl}/policy/endorsement/save-endorsement-contact`;
    return this.post<any>(url, { body: payload });
  }

  availableEndorsementForms(
    payload: AvailableEndorsementRequest
  ): Observable<any> {
    const url = `${this.serviceBaseUrl}/policy/endorsement/get-available-endorsement-forms`;
    return this.post<any>(url, { body: payload });
  }

  getEndorsementForms(payload: AvailableEndorsementRequest): Observable<any> {
    const url = `${this.serviceBaseUrl}/policy/endorsement/get-endorsement-forms`;
    return this.post<any>(url, { body: payload });
  }

  saveEndorsementForm(payload: any): Observable<any> {
    const url = `${this.serviceBaseUrl}/policy/endorsement/save-endorsement-form`;
    return this.post<any>(url, { body: payload });
  }

  getEndorsementContacts(
    payload: AvailableEndorsementRequest
  ): Observable<any> {
    const url = `${this.serviceBaseUrl}/policy/endorsement/get-endorsement-contacts`;
    return this.post<any>(url, { body: payload });
  }

  deleteEndorsementForms(
    payload: AvailableEndorsementRequest
  ): Observable<any> {
    const url = `${this.serviceBaseUrl}/policy/endorsement/delete-endorsement-form`;
    return this.post<any>(url, { body: payload });
  }

  insuredNextEndorsementForms(
    payload: AvailableEndorsementRequest
  ): Observable<any> {
    const url = `${this.serviceBaseUrl}/policy/endorsement/endorsement-contact-next-step`;
    return this.post<any>(url, { body: payload });
  }

  formNextEndorsementForms(
    payload: AvailableEndorsementRequest
  ): Observable<any> {
    const url = `${this.serviceBaseUrl}/policy/endorsement/endorsement-form-next-step`;
    return this.post<any>(url, { body: payload });
  }

  submitEndorsementForms(
    payload: AvailableEndorsementRequest
  ): Observable<any> {
    const url = `${this.serviceBaseUrl}/policy/endorsement/submit-endorsement`;
    return this.post<any>(url, { body: payload });
  }
}
